<template>
  <div class="language" @click="handleSetLanguage">
    <img
        src="./en.svg"
        alt=""
        class="language_img"
    />
  </div>
</template>

<script>
import Cookies from "js-cookie";

export default {
  name: "LangSelect",
  computed: {
    language() {
      return this.$i18n.locale
    }
  },
  methods: {
    handleSetLanguage() {
      const lang = this.language === 'zh' ? 'en' : 'zh'
      this.$i18n.locale = lang
      Cookies.set('language', lang)
      let messageMap = {
        zh: '语言切换成功！',
        en: 'Switch Language Success!'
      }
      this.$message({
        message: messageMap[lang],
        type: 'success'
      })
    }
  },
}
</script>
<style lang="scss" scoped>
.language {
  cursor: pointer;
  .language_img {
    width: 24px;
    height: 24px;
    vertical-align: middle;
  }
}
</style>

